import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsDelEdge;
(function (NsDelEdge) {
    /** Command: 用于注册named factory */
    NsDelEdge.command = XFlowEdgeCommands.DEL_EDGE;
    /** hookName */
    NsDelEdge.hookKey = 'delEdge';
    let ErrEnum;
    (function (ErrEnum) {
        ErrEnum["EDGE_NOT_EXIST"] = "edge is not exist";
        ErrEnum["EDGE_INVALID_CELL"] = "this is not a valid cell";
        ErrEnum["X6_DELETE_FAILED"] = "x6 throw err when call delete edge";
        ErrEnum["SERVICE_REJECT"] = "service reject to delete";
    })(ErrEnum = NsDelEdge.ErrEnum || (NsDelEdge.ErrEnum = {}));
})(NsDelEdge || (NsDelEdge = {}));
let DelEdgeCommand = 
/** 创建节点命令 */
class DelEdgeCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.delEdge.call(
            /** 执行 hooks pipeline处理args */
            args, 
            /** 执行 callback */
            (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { edgeConfig, x6Edge, deleteEdgeService, commandService, options } = handlerArgs;
                let edgeCell = x6Edge;
                /** 没有edgeCell时查找cell */
                if (!edgeCell) {
                    edgeCell = yield this.findEdgeById(edgeConfig);
                    if (!edgeCell) {
                        console.error(NsDelEdge.ErrEnum.EDGE_NOT_EXIST, edgeConfig);
                        return { err: NsDelEdge.ErrEnum.EDGE_NOT_EXIST };
                    }
                }
                const isEdge = edgeCell && edgeCell.isEdge();
                if (!isEdge) {
                    console.error(NsDelEdge.ErrEnum.EDGE_NOT_EXIST, edgeCell);
                    return { err: NsDelEdge.ErrEnum.EDGE_NOT_EXIST };
                }
                if (deleteEdgeService) {
                    /** 需要请求接口 */
                    const canDelete = yield deleteEdgeService(handlerArgs);
                    if (!canDelete) {
                        return { err: NsDelEdge.ErrEnum.SERVICE_REJECT };
                    }
                }
                try {
                    const targetCell = edgeCell.getTargetCell();
                    const sourceCell = edgeCell.getSourceCell();
                    const sourcePortId = edgeCell.getSourcePortId();
                    const targetPortId = edgeCell.getTargetPortId();
                    const source = sourceCell.id;
                    const target = targetCell.id;
                    /** 执行remove */
                    edgeCell.remove(Object.assign(Object.assign({}, options), { isCommand: true }));
                    /** 创建 undo */
                    const undo = Disposable.create(() => {
                        commandService.executeCommand(XFlowEdgeCommands.ADD_EDGE.id, {
                            edgeConfig: { source, target, sourcePortId, targetPortId },
                        });
                    });
                    /** add undo */
                    this.ctx.addUndo(undo);
                    return {
                        err: null,
                        edgeConfig: { source, target, sourcePortId, targetPortId },
                        targetCell,
                        sourceCell,
                        sourcePortId,
                        targetPortId,
                    };
                }
                catch (error) {
                    console.error(NsDelEdge.ErrEnum.X6_DELETE_FAILED, error);
                    return { err: NsDelEdge.ErrEnum.X6_DELETE_FAILED };
                }
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.findEdgeById = (edge) => __awaiter(this, void 0, void 0, function* () {
            const graph = yield this.ctx.getX6Graph();
            const cell = graph.getCellById(edge.id);
            return cell;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], DelEdgeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DelEdgeCommand.prototype, "init", null);
DelEdgeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsDelEdge.command.id },
    })
    /** 创建节点命令 */
], DelEdgeCommand);
export { DelEdgeCommand };
//# sourceMappingURL=edge-del.js.map